import { useQuery } from '@tanstack/react-query'
import { ApiError, fetchSearch, type SearchResponse } from '../lib/api'
import { hasTokens } from '../lib/auth'

export function useSearch(q: string, limit: number = 5) {
  const trimmed = q.trim()
  return useQuery<SearchResponse, ApiError>({
    queryKey: ['search', trimmed, limit],
    queryFn: () => fetchSearch(trimmed, limit),
    enabled: hasTokens() && trimmed.length >= 2,
    staleTime: 5_000,
    retry: false,
  })
}
